// @flow

export { speiValidator } from './validator';
